import { render, staticRenderFns } from "./ChangeBorrowTypeModal.vue?vue&type=template&id=c38fec12&scoped=true&"
import script from "./ChangeBorrowTypeModal.vue?vue&type=script&lang=js&"
export * from "./ChangeBorrowTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38fec12",
  null
  
)

export default component.exports